import * as React from "react";
import {useEffect} from "react";
import {Button, Header, Modal} from "semantic-ui-react";
import {FtpExplorerShowFileSystemEntry} from "../FtpExplorerShowFileSystemEntry";
import {FileSystemEntry} from "../../../../../../generated-ftp/api";
import {backend} from "../../../../../../xconvert-backend";
import {authentication} from "../../../../../../authentication";
import {FaDownload, FaRegFileZipper} from "react-icons/fa6";
import {ftp} from "../../../../../../xconvert-ftp";
import {ConfigContext} from "../../../../context/ConfigContext";

export interface FtpExplorerFileDownloadModalProps {
    isOpen: boolean;
    onClose: (success: boolean) => void;
    fileEntry: FileSystemEntry;
    path: string;
}

export function FtpExplorerSignedDownloadFileModal(props: FtpExplorerFileDownloadModalProps) {

    const context = React.useContext(ConfigContext);

    const [loading, setLoading] = React.useState(false);
    const [signature, setSignature] = React.useState<string>(null);
    const [zipCreated, setZipCreated] = React.useState(false);
    const [filePath, setFilePath] = React.useState(props.fileEntry.name);

    useEffect(() => {
        console.log("[FtpExplorerSignedDownloadFileModal] isOpen changed: ", props.isOpen);

        async function getSignature(
            path = props.path,
            fileName = props.fileEntry.name
        ) {
            setLoading(true);

            let auth = ftp.withTokenAuthHeader(authentication.token)
            let resp = await ftp.ftpApi.createDownloadSignature(
                fileName,
                path,
                context.companyId,
                auth
            )

            console.log("[FtpExplorerSignedDownloadFileModal] SignedUrl response: ", resp);
            setSignature(resp.signedUrl);
            setZipCreated(resp.zipCreated);
            setFilePath(resp.filePath);

        }

        getSignature().then(() => {
            setLoading(false)
        })

    }, [props.isOpen]);

    async function deleteZipFile() {
        let auth = backend.withTokenAuthHeader(authentication.token);
        let response = await ftp.ftpApi.deleteFile(
            filePath,
            context.companyId,
            auth
        )

        if (response.success) {
            console.log("[FtpExplorerSignedDownloadFileModal] Deleted zip file successfully");
        } else {
            console.log("[FtpExplorerSignedDownloadFileModal] Error deleting zip file: ", response.errorMessage);
        }
    }

    async function handleClose() {
        if (zipCreated) {
            //deleteZipFile().then() //TODO: check if download was successful before deleting (how?)
        }
        props.onClose(false);
    }

    function downloadButton() {
        const url = `/ftp/files/download/` + signature;
        return <Button
            className="ui button"
            color="green"
            style={{padding: "8px 16px"}}
            onClick={e => {
                e.preventDefault();
                window.open(url, '_blank');
                handleClose().then();
            }}
        >
            <FaDownload/> Download
        </Button>
    }

    function drawZipInfo() {
        return (
            <div style={{
                backgroundColor: "#fff3cd",
                color: "#856404",
                border: "2px solid #ffeeba",
                borderRadius: "6px",
                padding: "18px",
                margin: "18px 0",
                fontSize: "1.2em",
                fontWeight: "bold"
            }}>
                ⚠️ Warning: The downloaded file was created as a ZIP archive on the server.
                <br/>
                <FaRegFileZipper/> <span style={{fontWeight: "bold", fontSize: "1.5em"}}>
                    <FaRegFileZipper/> {filePath}
                </span>
                <br/>
                <span style={{color: "#d9534f"}}>
                    Please make sure to manually delete this file after downloading!
                </span>
            </div>
        );
    }

    return (
        <Modal
            open={props.isOpen}
            onClose={handleClose}
            dimmer="blurring"
            size="small"
        >
            <Header icon="browser" content="Download File (signed)"/>
            <Modal.Content>
                <p>Downloading this file?</p>
                <FtpExplorerShowFileSystemEntry file={props.fileEntry}/>

                {zipCreated && drawZipInfo()}
                {loading && <p>Loading signature...</p>}
                {!loading && signature != null && downloadButton()}

                <Button onClick={handleClose}>close</Button>
            </Modal.Content>
        </Modal>
    );
}
